import { render, staticRenderFns } from "./sme-kyc-form.vue?vue&type=template&id=5afd305f&scoped=true&"
import script from "./sme-kyc-form.vue?vue&type=script&lang=js&"
export * from "./sme-kyc-form.vue?vue&type=script&lang=js&"
import style0 from "./sme-kyc-form.vue?vue&type=style&index=0&id=5afd305f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5afd305f",
  null
  
)

export default component.exports